export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"/ms-icon-144x144.png"},{"name":"theme-color","content":"#ffffff"},{"hid":"description","name":"description","content":"Официальный сайт Отеля Ресторана \"Леон\" - Один из лучших отелей и ресторанов в Абхазии, расположенный на набережной Сухума"},{"hid":"keywords","name":"keywords","content":"отель, ресторан, леон, абхазия, сухум, набережная, отдых, размещение, бронирование, номера"},{"property":"og:site_name","content":"LEON BOUTIQUE HOTEL"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https://leonhotel.ru"},{"hid":"og:title","property":"og:title","content":"LEON BOUTIQUE HOTEL - Бутик-отель и ресторан в Сухуме, Абхазия"},{"hid":"og:description","property":"og:description","content":"Официальный сайт Отеля Ресторана \"Леон\" - Один из лучших отелей и ресторанов в Абхазии, расположенный на набережной Сухума"},{"hid":"og:image","property":"og:image","content":"/img/hotel-og-image.jpg"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"LEON BOUTIQUE HOTEL - Бутик-отель и ресторан в Сухуме, Абхазия"},{"name":"twitter:description","content":"Официальный сайт Отеля Ресторана \"Леон\" - Один из лучших отелей и ресторанов в Абхазии, расположенный на набережной Сухума"},{"name":"twitter:image","content":"/img/hotel-og-image.jpg"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"hid":"canonical","rel":"canonical","href":"https://leonhotel.ru"},{"rel":"apple-touch-icon","sizes":"57x57","href":"/apple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"/apple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/apple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/apple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"/apple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/apple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/apple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/apple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-icon-180x180.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/android-icon-192x192.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/manifest.json"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"\n            (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n            m[i].l=1*new Date();\n            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n            (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n            ym(99727965, \"init\", {\n                  clickmap:true,\n                  trackLinks:true,\n                  accurateTrackBounce:true,\n                  webvisor:true\n            });","tagPosition":"bodyClose"}],"noscript":[],"title":"LEON BOUTIQUE HOTEL"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false